if (!customElements.get("v5-scroll-pic-text")) {
  class V5ScrollPicText extends HTMLElement {
    constructor() {
      super();
      this.isMobile = window.innerWidth < 1024;
      this.currentIndex = 0;
      this.scrollTriggerInstance = null;
      this.pdpTop = 0;
      this.top = 0;
    }

    connectedCallback() {
      if (this.isMobile) {
        this.initMobile();
      } else {
        this.pdpTop = this.getPdpTabHeight();
        this.top = this.getHeaderHeight();
        document.addEventListener('DOMContentLoaded', () => {
          this.initScrollTrigger();
        });
      }
    }

    disconnectedCallback() {
      // 组件销毁时清理
      if (this.scrollTriggerInstance) {
        this.scrollTriggerInstance.kill();
        this.scrollTriggerInstance = null;
      }
    }

    // 移动端手风琴
    initMobile() {
      const titles = this.querySelectorAll('.mb-card-title');
      titles.forEach(title => {
        title.addEventListener('click', () => {
          const index = title.dataset.index;
          const card = this.querySelector(`.mb-card[data-index='${index}']`);
          card.classList.add('active')
          this.querySelectorAll('.mb-card').forEach(el => {
            if (el != card) el.classList.remove('active')
          })
        });
      });
    }

    initScrollTrigger() {
      if (!window._scrollTriggerRegistered) {
        gsap.registerPlugin(ScrollTrigger);
        window._scrollTriggerRegistered = true;
      }

      const container = this.querySelector("#scroll-pic-text");
      const images = gsap.utils.toArray(container.querySelectorAll(".scence-image"));
      const texts = gsap.utils.toArray(container.querySelectorAll(".text-block"));
      const subs = texts.map(t => t.querySelector(".sub-title"));
      const totalFrames = images.length;

      // --- 激活指定帧 ---
     const activateFrame = (index) => {
        images.forEach((img, i) => {
            gsap.to(img, { autoAlpha: i === index ? 1 : 0, duration: 0.3, ease: "power1.out", overwrite: "auto" });
        });

        subs.forEach((sub, i) => {
            if (i === index) {
                gsap.to(sub, {  maxHeight: sub.scrollHeight,  opacity: 0.6,  duration: 0.3,  ease: "power1.out"  });
            } else {
                gsap.to(sub, {  maxHeight: 0,  opacity: 0,  duration: 0.3,  ease: "power1.in"  });
            }
        });

        texts.forEach((txt, i) => txt.classList.toggle("active", i === index));
        };



      // --- 初始化第一帧 ---
      activateFrame(0);

      // --- 创建 timeline 用于平滑动画 ---
      const tl = gsap.timeline({ paused: true });
      for (let i = 0; i < totalFrames; i++) {
        // timeline 仅用于图片/文字过渡，不控制 active
        if (i > 0) {
          tl.to(images[i], {duration: 0.1 }, i * 0.01)
            .to(images[i - 1], { duration: 0.1 }, i * 0.01);
        }
      }

      const type = this.getAttribute("data-type");
      // --- ScrollTrigger ---
      this.scrollTriggerInstance = ScrollTrigger.create({
        trigger: container,
        start: () => {
            const topOffset = type === "product"
              ? this.getPdpTabHeight()
              : this.getHeaderHeight();
            return `top ${topOffset}px`;
        },
        end: `bottom 25%`,
        pin: true,
        scrub: 0.3,
        snap: 1 / (totalFrames - 1),
        // markers: true,
        animation: tl,
        onUpdate: self => {
          // 计算当前帧索引
          const index = Math.min(totalFrames - 1, Math.round(self.progress * (totalFrames - 1)));
          activateFrame(index); // 动态控制 active / sub-title
        }
      });

      // --- ResizeObserver 保证响应式 ---
      const observer = new ResizeObserver(this.debounce(() => this.scrollTriggerInstance.refresh(), 100));
      observer.observe(container);


    }
    getHeaderHeight() {
      const header = document.querySelector(".jky-header") || document.querySelector("header-v5");
      if (!header) return 0;
      const headerTop = parseFloat(header.style.top) || 0;
      if (headerTop < 0) return 0;
      const cssHeight = parseFloat(getComputedStyle(document.body).getPropertyValue("--jky-header-h")) || 0;
      return Math.max(cssHeight, header.offsetHeight);
    }

    getPdpTabHeight() {
      return document.querySelector(".product-tabs-box")?.offsetHeight || 0;
    }

    debounce(fn, delay) {
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), delay);
      };
    }
  }

  customElements.define("v5-scroll-pic-text", V5ScrollPicText);
}

